// add custom MDX components here
const components = {}

export default components
